import './ReportManagement.css';
import { useState, useEffect } from 'react';
import ReportRequest from './components/ReportRequest';
import ReportTemplate from './components/ReportTemplate';
import { useSearchParams } from 'react-router-dom';
const ReportManagement = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.get('t') || 'request');
  useEffect(() => {
    setActiveTab(searchParams.get('t') || 'request');
  }, [searchParams]);

  return (
    <div className="report-management-container page-container">
      
      <div className="tabs grid-cols-2 w-quarter">
        <button className={`tab ${activeTab === 'request' ? 'active' : ''}`} onClick={() => {
          const current = Object.fromEntries(searchParams.entries());
          setSearchParams({ ...current, t: 'request' });
        }}>요청</button>
        <button className={`tab ${activeTab === 'template' ? 'active' : ''}`} onClick={() => {
          const current = Object.fromEntries(searchParams.entries());
          setSearchParams({ ...current, t: 'template' });
        }}>템플릿</button>
      </div>

      <div className="report-management-content">
        {activeTab === 'request' && (
          <ReportRequest />
        )}
        {activeTab === 'template' && (
          <ReportTemplate />
        )}
        
      </div>
    </div>
  );
};

export default ReportManagement; 